module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'search-form' && templateVars.config ?
				templateVars.config :
				{
	"maxElemDisplay": 5,
	"quickSearchLink": "${rootUrl}/quicksearch/${searchQuery}",
	"searchLink": "${rootUrl}/search/${searchQuery}"
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/search-form/config.yaml
// module id = 79
// module chunks = 0